module.exports = __webpack_public_path__ + "img/si.si4b2b845.svg";